import React from 'react';
import { SvgIcon } from '@material-ui/core';

const NavigateMinus = props => (
    <SvgIcon shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="nonzero" clipRule="evenodd" viewBox="0 0 10240 10240" {...props}>
	<path id="curve0" d="M8320 5760l0 -1280c0,-176 -144,-320 -320,-320l-5760 0c-176,0 -320,144 -320,320l0 1280c0,176 144,320 320,320l5760 0c176,0 320,-144 320,-320z"/>
    </SvgIcon>
);
export default NavigateMinus;

